import React,{useState} from "react";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import AuthService from "./AuthService";
import "./Login.css";

export default function Login(){
 const navigate=useNavigate();
 const [identifier,setIdentifier]=useState("");
 const [password,setPassword]=useState("");
 const [showPassword,setShowPassword]=useState(false);
 const [loading,setLoading]=useState(false);

 const submit=async event=>{
  event.preventDefault();

  if(!identifier.trim()||!password){
   toast.error("Enter your username and password.");
   return;
  }

  try{
   setLoading(true);
   const response=await AuthService.login({
    identifier:identifier.trim(),
    password,
   });

   if(response.user?.must_change_password){
    window.location.href="/change-password";
    return;
   }

   const type=response.user?.access_type;
   const role=String(response.user?.role||"").trim().toUpperCase();
   const canViewManagementDashboard=
    ["DIRECTOR","SYSTEM ADMINISTRATOR"].includes(role);
   window.location.href=
    type==="POLICY_HOLDER"
     ?"/policyholder/dashboard"
     :type==="AGENT"
     ?"/agent/dashboard"
     :type==="PARTNER"
     ?"/partner/ecosure"
     :canViewManagementDashboard
     ?"/dashboard"
     :"/notifications";
  }catch(error){
   const status=error.response?.status;
   toast.error(
    status===429
     ?"Too many failed attempts. Wait a few minutes and try again."
     :"Invalid username or password."
   );
  }finally{
   setLoading(false);
  }
 };

 return <div className="assure-login">
  <div className="assure-login__brand">
   <img src="/bronix-logo.png" alt="Bronix Technologies"/>
   <span>A product of Bronix Technologies</span>
  </div>

  <div className="assure-login__heading">
   <p>Secure platform access</p>
   <h2>Welcome to NetriAssure</h2>
   <span>Sign in using the credentials issued to you.</span>
  </div>

  <form onSubmit={submit}>
   <div className="assure-field">
    <label htmlFor="identifier">Username or account number</label>
    <div className="assure-field__control">
     <i className="bi bi-person"/>
     <input
      id="identifier"
      type="text"
      autoComplete="username"
      autoCapitalize="none"
      spellCheck="false"
      placeholder="Enter your username"
      value={identifier}
      onChange={event=>setIdentifier(event.target.value)}
     />
    </div>
   </div>

   <div className="assure-field">
    <label htmlFor="password">Password</label>
    <div className="assure-field__control">
     <i className="bi bi-lock"/>
     <input
      id="password"
      type={showPassword?"text":"password"}
      autoComplete="current-password"
      placeholder="Enter your password"
      value={password}
      onChange={event=>setPassword(event.target.value)}
     />
     <button
      type="button"
      className="assure-field__toggle"
      onClick={()=>setShowPassword(value=>!value)}
      aria-label={showPassword?"Hide password":"Show password"}
     >
      <i className={`bi ${showPassword?"bi-eye-slash":"bi-eye"}`}/>
     </button>
    </div>
   </div>

   <button
    type="button"
    className="assure-forgot-link"
    onClick={()=>navigate("/forgot-password")}
   >
    Forgot your password?
   </button>

   <button
    type="submit"
    className="assure-submit"
    disabled={loading}
   >
    <span>{loading?"Verifying access...":"Sign in"}</span>
    {!loading&&<i className="bi bi-arrow-up-right"/>}
   </button>
  </form>

  <div className="assure-login__security">
   <i className="bi bi-shield-check"/>
   <p>
    Access is protected by encrypted authentication, failed-attempt
    monitoring and temporary lockout controls.
   </p>
  </div>
 </div>
}